<template>
  <DataTable
    :striped-rows="true"
    :lazy="true"
    responsive-layout="scroll"
    filter-display="row"
  >
    <slot name="before" />
    <Column
      field="codeControl"
      :header="$t('entity.barcode.code')"
      :sortable="true"
      sort-field="barcodeRange.start"
      :show-filter-menu="false"
      class="col-tab"
      style="width:200px"
    >
      <template #body="{ data }">
        <div>
          <a
            type="button"
            class="cursor-pointer"
            @click="onClickCode(data.barcodeRange)"
          >
            {{ $t('entity.barcode.from') }} {{ data.barcodeRange.start }} {{ $t('entity.barcode.to') }} {{ data.barcodeRange.end }}
          </a>
        </div>
      </template>
    </Column>
    <Column
      field="barcodeRange.creationUser.firstname"
      :header="$t('entity.control.associationUser')"
      :sortable="true"
      sort-field="creationUser.firstname"
      :show-filter-menu="false"
      class="col-tab"
    >
      <template #body="{ data }">
        {{ data.creationUser.firstname }} {{ data.creationUser.lastname }}
      </template>
    </Column>
    <Column
      field="creationDate"
      :header="$t('entity.control.associationDate')"
      :sortable="true"
      sort-field="creationDate"
      :show-filter-menu="false"
      class="col-tab"
      :style="{width: '200px'}"
    >
      <template #body="{ data }">
        <div v-if="data.creationDate">
          {{ formatDateTime(data.creationDate) }}
        </div>
      </template>
    </Column>
    <Column
      field="deletionUser.firstname"
      :header="$t('entity.control.disassociationUser')"
      :sortable="true"
      sort-field="deletionUser.firstname"
      :show-filter-menu="false"
      class="col-tab"
    >
      <template #body="{ data }">
        <div v-if="data.deletionUser">
          {{ data.deletionUser.firstname }} {{ data.deletionUser.lastname }}
        </div>
      </template>
    </Column>
    <Column
      field="deletionDate"
      :header="$t('entity.control.disassociationDate')"
      :sortable="true"
      sort-field="deletionDate"
      :show-filter-menu="false"
      filter-field="deleted"
      class="col-tab"
      :style="{width: '200px'}"
    >
      <template #filter="{ filterModel, filterCallback }">
        <TriStateCheckbox
          v-model="filterModel.value"
          @change="filterCallback()"
        />
      </template>
      <template #body="{ data }">
        <div v-if="data.deletionDate">
          {{ formatDateTime(data.deletionDate) }}
        </div>
      </template>
    </Column>

    <BarcodeRangeDetailDialog
      v-if="selected && isContact"
      v-model:visible="showDetail"
      :barcode="selected"
    />

    <BarcodeEditDialog
      v-if="selected && !isContact"
      v-model:visible="showDetail"
      :barcode="selected"
    />
  </DataTable>
</template>
<script>
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import TriStateCheckbox from "primevue/tristatecheckbox";
import BarcodeRangeDetailDialog from "@/components/barcodes/BarcodeRangeDetailDialog.vue";
import BarcodeEditDialog from "@/components/barcodes/BarcodeEditDialog.vue";
import {CONTACT_ROLE} from "@/shared/constants";

export default {
  name: "ControlTable",
  components: {
    DataTable,
    Column,
    TriStateCheckbox,
    BarcodeRangeDetailDialog,
    BarcodeEditDialog
  },
  computed: {
    isContact() {
      return this.$store.state.auth.user.role === CONTACT_ROLE;
    },
  },
  data() {
    return {
      showDetail: false,
      selected: null,
    }
  },
  methods: {
    formatDateTime(date) {
      return new Date(date).toLocaleString(this.$i18n.locale)
    },
    onClickCode(barcodeRange) {
      this.selected = barcodeRange;
      this.showDetail = true;
    }
  }
}
</script>
